import { useNuxtData, useRoute } from '#imports'
import { computed } from 'vue'

import { PRODUCT_ROUTES } from '~/scopes/product-core/route-names'

export function useMasterPP(route = useRoute()) {
  const { data } = useNuxtData(`MasterPP-${route.params.slug}`)

  const masterPPProductId = computed(() => data.value?.productId)
  const masterPPGrade = computed(() => data.value?.grade)
  const masterPPSpecialOfferType = computed(() => data.value?.specialOfferType)

  const isMasterPPUrl = computed(
    () => route.name === PRODUCT_ROUTES.MASTER_PRODUCT_PAGE,
  )

  return {
    masterPPProductId,
    masterPPGrade,
    masterPPSpecialOfferType,
    isMasterPPUrl,
  }
}
